module.exports = __webpack_public_path__ + "img/lock-open.36827735.svg";